<div class="flex items-center gap-2" (click)="handleToggleSort(columnKey()!)">
  <span>{{ columnName() }}</span>
  @if (sortBy() === columnKey() && sortOrder() === 'asc') {
    <i class="pi pi-sort-amount-up-alt"></i>
  }
  @if (sortBy() === columnKey() && sortOrder() === 'desc') {
    <i class="pi pi-sort-amount-down"></i>
  }
  @if (sortBy() !== columnKey()) {
    <i class="pi pi-sort-alt text-opacity-30"></i>
  }
</div>
